// @flow
import { connect } from 'react-redux';

import DomainInput from '../../components/DomainInput';
import type { FullState } from '../../types';
import {
  selectSearchLoading,
  selectSearchValue,
} from '../modules/selectors/search';

const mapStateToProps = (state: FullState) => ({
  value: selectSearchValue(state),
  loading: selectSearchLoading(state),
});

// $FlowFixMe[underconstrained-implicit-instantiation]
export default (connect(
  mapStateToProps,
  // $FlowFixMe[cannot-resolve-name]
)(DomainInput): Class<ConnectedComponent<mixed, any>> & any);
